// src/mobile/index.ts
import { setNavigationBarConfig } from './navigation';
import {
  setDetailNavigationBarConfig,
  removeDetailNavigationBarListeners,
} from './detail-navigation';
import {
  setSubNavigationConfig,
  updateSubNavigationItem,
  setSelectedSubNavigationItem,
  insertSubNavigationItem,
  removeSubNavigationItem,
} from './sub-navigation';
import { setFloatingActionButtonConfig } from './fab';
import { activeSearch, cancelSearch } from './search';
import {
  registerEvent,
  unregisterEvent,
  removeEventAllListeners,
} from './event-manager';

export const mobileUI = {
  setNavigationBarConfig,
  setDetailNavigationBarConfig,
  removeDetailNavigationBarListeners,
  setSubNavigationConfig,
  setSelectedSubNavigationItem,
  updateSubNavigationItem,
  insertSubNavigationItem,
  removeSubNavigationItem,
  setFloatingActionButtonConfig,
  registerEvent,
  activeSearch,
  cancelSearch,
  unregisterEvent,
  removeEventAllListeners,
};

export * from './navigation';
export * from './detail-navigation';
export * from './sub-navigation';
export * from './fab';
export * from './search';
export * from './event-manager';
export * from './types';
